module.exports = __webpack_public_path__ + "static/pattern-eyes-fa1bfd65cddd26ed7a956cb28bb21bde.png";